import { dehydrate, QueryClient } from '@tanstack/react-query'
import type { AgentGetBankAccountsInput } from '../api'
import userAgentBankService from './agent-bank.service'
import { EAgentBankQueryKey } from './agent-bank.types'

export const userAgentBankGetOptions = (filter: AgentGetBankAccountsInput) => {
  return {
    queryKey: [EAgentBankQueryKey.GET, filter],
    queryFn: () => userAgentBankService.get(filter),
  }
}

export const prefetchUserAgentBanks = async (
  filter: AgentGetBankAccountsInput,
) => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(userAgentBankGetOptions(filter))
  return dehydrate(queryClient)
}
